module.exports = __webpack_public_path__ + "static/moz-04c6cd6ced715c30209c2bdf48da36b5.png";